import styled from 'styled-components';

export const FormMultiDoubleOptInWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 32px;
`;

export const FormMultiDoubleOptInToggleWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 8px;

    .MuiFormControlLabel-root {
        margin-right: 0;
        align-items: start;
    }

    .MuiFormControlLabel-label {
        margin: 0;
    }
`;

export const FormMultiDoubleOptInToggleLabel = styled.span`
    word-wrap: break-word;
    white-space: normal;
    display: block;
    margin-left: 12px;
`;


export const FormMultiDoubleOptInCustomizeWrapper = styled.div`
    padding-left: 4px;
`;